
import { nextTick } from 'vue'

/**
 * 特征提取的API调用函数
 * @param {string} content - 需要提取特征的文本内容
 * @returns {Promise} - 返回一个Promise对象，包含API响应结果
 */
export async function featureExtraction(content) {
  try {
    const response = await fetch('/api/feature/extraction', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        content: content,
      }),
    });

    // 检查响应是否成功
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    // 解析JSON响应并返回数据
    const data = await response.json();
    return data
  } catch (error) {
    // 捕获并处理错误
    console.error('文本检查请求失败:', error);
    throw error; // 重新抛出错误，让调用者可以处理
  }
}

export async function featureCompare(content) {
  try {
    const response = await fetch('/api/feature/comparison', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        content: content,
      }),
    });
    
    // 检查响应是否成功
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    // 解析JSON响应并返回数据
    const data = await response.json();
    return data
  } catch (error) {
    // 捕获并处理错误
    console.error('文本检查请求失败:', error);
    throw error; // 重新抛出错误，让调用者可以处理
  }
}